import { createRpc } from '@lightprotocol/stateless.js';
import { PublicKey } from '@solana/web3.js';

export async function getSolanaBalance(walletAddress: string) {
  const RPC_URL = process.env.NEXT_PUBLIC_SOLANA_RPC_URL;
  try {
    const connection = createRpc(RPC_URL, RPC_URL, RPC_URL);

    const publicKey = new PublicKey(walletAddress);
    const balance = await connection.getBalance(publicKey);
    return balance / 1e9; // Convert from lamports to SOL
  } catch (error) {
    console.error('Error fetching balance:', error);
  }
}
